module.exports = __webpack_public_path__ + "static/media/Italian_Carla BG-40.a94c31f0.png";